import React from 'react';
import './App.css';
import { AppRoutes } from './routes/AppRoutes';

const App = () => {
  return (
    <div className="bg-[#0A0A0A]">
      <AppRoutes />
    </div>
  );
};

export default App;